module.exports = __webpack_public_path__ + "static/media/pack-solid.cf5be1e3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/pack-solid.svg
// module id = 42
// module chunks = 0